module.exports = __webpack_public_path__ + "img/card.82cf746e.svg";